import type { Resource } from '../../';
export const country_countries_BA: Resource = {"default":"Bosnia & Herzegovina"};
